import AnalysesRoute from '@/routes/analyses/AnalysesRoute';
import { analysisActions } from '@/stores/analysisStore';
import PathwayAnalysisRoute from './PathwayAnalysisRoute';
import SystemAnalysisRoute from './SystemAnalysisRoute';
import { systemAnalysisActions } from '@/stores/systemAnalysisStore';
import { getSystem } from '@/api/systems';

const analysesRouter = {
  path: '/projects/:projectId/analysis',
  element: <AnalysesRoute />,
  handle: {
    title: _ => {
      return { title: `Analyze` };
    },
  },
  children: [
    {
      path: '/projects/:projectId/analysis/pathways/:pathwayId',
      id: 'analysis',
      element: <PathwayAnalysisRoute />,
      errorElement: <PathwayAnalysisRoute />,
      loader: async ({ params: { pathwayId } }) => {
        const promise = analysisActions.init(pathwayId);
        return { promise };
      },
      handle: {
        crumb: pathway => ['Pathways', pathway?.name],
        title: pathway => {
          return { title: `Analyze Pathway: ${pathway?.name}` };
        },
      },
    },
    {
      path: '/projects/:projectId/analysis/systems/:systemId',
      id: 'system-analysis',
      element: <SystemAnalysisRoute />,
      errorElement: <SystemAnalysisRoute />,
      loader: async ({ params: { systemId } }) => {
        const { data } = await getSystem(systemId);
        const systemAnalysis = systemAnalysisActions.init(data);
        return { ...data, systemAnalysis };
      },
      handle: {
        crumb: system => ['Systems', system?.name],
        title: system => {
          return { title: `Analyze System: ${system?.name}` };
        },
      },
    },
  ],
};

export default analysesRouter;
